import React from "react"
import { Link } from "gatsby-link"
import { componentStyles } from "@mallardbay/lib-react-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch"

import SimpleGrid from "~components/shared/todo-lib-react-components/simple-grid"
import { useStateSuggestions } from "~utils/use-search-suggestions-for-trip"
import {
    Text,
    TextLargeBold,
} from "~components/shared/todo-lib-react-components/text"
import Card from "~components/shared/todo-lib-react-components/card"
import { VerticalStack } from "~components/shared/todo-lib-react-components/vertical-stack"
import LoadingOrErrorContainer from "~components/shared/todo-lib-react-components/loading-or-error-container"
import { getSearchRouteWithState } from "~utils/navigation-helpers"
import COPY from "~config/copy-constants"

export default function RecommendedSearches() {
    const styles = useStyleProps()
    const { items, isLoading, error } = useStateSuggestions()
    const itemsToShow = items.slice(0, 4)

    return (
        <LoadingOrErrorContainer
            isLoading={isLoading}
            error={error}
            shouldRenderChildren={!isLoading && !error}
        >
            <TextLargeBold style={styles.header}>
                {COPY.EXPLORE_DESTINATIONS}
            </TextLargeBold>
            <SimpleGrid columns={{ base: 2, md: 2, lg: 4 }}>
                {itemsToShow.map(({ value }) => (
                    <Link to={getSearchRouteWithState(value)} key={value}>
                        <Card key={value}>
                            <VerticalStack>
                                <FontAwesomeIcon
                                    icon={faSearch}
                                    fontSize={22}
                                />
                                <Text>{value}</Text>
                            </VerticalStack>
                        </Card>
                    </Link>
                ))}
            </SimpleGrid>
        </LoadingOrErrorContainer>
    )
}

function useStyleProps() {
    return componentStyles({
        header: {
            marginBottom: "24px",
        },
    })
}
